export let UpgradeMessageEventKeys;

(function (UpgradeMessageEventKeys) {
  UpgradeMessageEventKeys["OPEN_MODAL"] = "__ui_addon_upgrades_OPEN_MODAL";
  UpgradeMessageEventKeys["FETCH_UPGRADE_POINT"] = "__ui_addon_upgrades_FETCH_UPGRADE_POINT";
})(UpgradeMessageEventKeys || (UpgradeMessageEventKeys = {}));